import { render, staticRenderFns } from "./AppPlaceholderVertical.vue?vue&type=template&id=2775f7f9&"
import script from "./AppPlaceholderVertical.vue?vue&type=script&lang=js&"
export * from "./AppPlaceholderVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports